/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Note_HelpInputs */

const en_history_note_help = /** @type {(inputs: History_Note_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was different, what will you change next time?`)
};

const de_history_note_help = /** @type {(inputs: History_Note_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was war anders, was machst du nächstes Mal anders?`)
};

/**
* | output |
* | --- |
* | "What was different, what will you change next time?" |
*
* @param {History_Note_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_note_help = /** @type {((inputs?: History_Note_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Note_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_note_help(inputs)
	return en_history_note_help(inputs)
});